import React from 'react';
import DimQuantitativeChart from './DimQuantitativeChart';

const DimensionalTypeBasedComponentMap = {
    //2: XComponent, // XComponent is a component that is used for type 2 Cantidad presupuestada ante cantidad ejecutada
};

const IndicatorUUIDBasedComponentMap = {
    // 'uuid': XComponent, // XComponent is a component that is used for a specific indicator
};

const DefaultComponent = DimQuantitativeChart;

const DimQuantitativeChartFactory = ({ indicatorDTO, objective }) => {
    // the order of prevalence is: indicatorUUID, dimensionalType, default
    const IndicatorUUIDComponent = IndicatorUUIDBasedComponentMap[indicatorDTO.indicatorUUID];
    if (IndicatorUUIDComponent) {
        return <IndicatorUUIDComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }

    const DimensionalTypeComponent = DimensionalTypeBasedComponentMap[indicatorDTO.dimensionalType.dimensionTypeId];
    if (DimensionalTypeComponent) {
        return <DimensionalTypeComponent indicatorDTO={indicatorDTO} objective={objective} />;
    }

    return <DefaultComponent indicatorDTO={indicatorDTO} objective={objective} />;
};

export default DimQuantitativeChartFactory;